// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import Card from '@bottlebooks/gatsby-design-system/src/components/Card/Card';
import { findRoomByStandName } from '@bottlebooks/gatsby-plugin-california-pdf/src/templates/VieVinum/helpers/rooms';
import { Box, Link, Text, Title } from '@bottlebooks/gatsby-theme-base';
import ExhibitorsList from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorsList/ExhibitorsList';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import React from 'react';
import { jsx } from 'theme-ui';
import ExhibitorsPageCards from '../ExhibitorsPage/ExhibitorsPageCards';
import getExhibitorRoomColors from '../../../../getExhibitorRoomColors';

export default function GroupedExhibitorsCard({ type, exhibitors, ...rest }) {
  const link = useLink();
  if (type === 'room') {
    const room = findRoomByStandName(exhibitors[0].stand?.name);
    const { primary, shadow } = getExhibitorRoomColors(exhibitors[0]);
    return (
      <Card
        elevation="none"
        sx={{ marginX: ['-gutter', 0], backgroundColor: shadow }}
        style={{ outline: `1px solid ${primary}` }}
        {...rest}
      >
        <RoomHeader
          room={room}
          primaryColor={primary}
          to={link.room?.(room)}
          sx={{ gridColumn: '1/-1' }}
        />
        <ExhibitorsList sx={{ gridAutoFlow: 'dense', padding: 3 }}>
          <ExhibitorsPageCards
            exhibitors={exhibitors}
            sx={{ outlineWidth: 1, boxShadow: 'none' }}
          />
        </ExhibitorsList>
      </Card>
    );
  }

  return (
    <Card sx={{ backgroundColor: 'nuanced' }} {...rest}>
      <ExhibitorsList sx={{ gridAutoFlow: 'dense', padding: [2, 3] }}>
        <ExhibitorsPageCards
          exhibitors={exhibitors}
          sx={{ boxShadow: 'borderSecondary' }}
        />
      </ExhibitorsList>
    </Card>
  );
}

function RoomHeader({ room, primaryColor, ...rest }) {
  const link = useLink();
  if (!room) return null;
  return (
    <>
      <Box
        as={Link}
        to={link.room(room)}
        sx={{
          color: room.colors?.onPrimary || 'onPrimary',
          backgroundColor: primaryColor,
          borderTopLeftRadius: 'default',
          borderRadius: 'default',
          paddingX: [2, 3],
          paddingTop: 5,
          paddingBottom: 0,
          textTransform: 'uppercase',
          zIndex: 'modal',
          position: 'sticky',
          top: 0,
          transition: 'opacity',
          ':hover': {
            opacity: 0.8,
            color: room.colors?.onPrimary || 'onPrimary',
          },
        }}
        {...rest}
      >
        <Title variant="small">{room.name}</Title>
      </Box>

      <Text
        sx={{
          paddingX: [2, 3],
          paddingTop: 1,
          paddingBottom: 3,
          color: room.colors?.primary,
          backgroundColor: room.colors?.onPrimary || 'onPrimary',
          borderBottom: 1,
          borderColor: room.colors?.primary,
          borderBottomLeftRadius: 'default',
          borderBottomRightRadius: 'default',
          zIndex: 'elevated',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textTransform: 'uppercase',
        }}
        {...rest}
      >
        {room.subtitle}
      </Text>
    </>
  );
}
